import { defineQuery } from '@rocicorp/zero';
import * as z from 'zod';
import { zql } from '../schema.js';
import { applyCursor } from '../util/apply-cursor.js';
import { HL7Direction, HL7Status } from '../database/schema.js';
export const ListHl7EventsFiltersInput = z.object({
    status: z.array(HL7Status).optional(),
    createdAtFrom: z.number().optional(),
    createdAtTo: z.number().optional(),
});
const ListInput = z.object({
    cursor: z
        .object({
        id: z.string(),
        createdAt: z.number(),
        direction: z.enum(['forward', 'backward']).default('forward'),
    })
        .optional(),
    sort: z
        .object({
        field: z.enum(['createdAt']).default('createdAt'),
        dir: z.enum(['asc', 'desc']).default('desc'),
    })
        .optional(),
    direction: HL7Direction.optional(),
    filters: ListHl7EventsFiltersInput.optional(),
    limit: z.number().optional(),
});
export const hl7EventsQueries = {
    listHl7Events: defineQuery(ListInput, ({ args }) => {
        const { filters } = args;
        let base = zql.HL7EventLog.where('id', 'IS NOT', null);
        if (args.direction) {
            base = base.where('direction', '=', args.direction);
        }
        if (filters) {
            if (filters.status && filters.status.length > 0) {
                base = base.where('status', 'IN', filters.status);
            }
            if (filters.createdAtFrom !== undefined) {
                base = base.where('createdAt', '>=', filters.createdAtFrom);
            }
            if (filters.createdAtTo !== undefined) {
                base = base.where('createdAt', '<=', filters.createdAtTo);
            }
        }
        base = applyCursor(base, { sort: args.sort, cursor: args.cursor, limit: args.limit });
        return base;
    }),
    getHl7EventById: defineQuery(z.string(), ({ args }) => {
        return zql.HL7EventLog.where('id', '=', args).one();
    }),
};
//# sourceMappingURL=hl7-event-log.queries.js.map